import { render, staticRenderFns } from "./StepsContrato.vue?vue&type=template&id=72e2014d&"
import script from "./StepsContrato.vue?vue&type=script&lang=js&"
export * from "./StepsContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StepsContrato.vue"
export default component.exports